import SimulatorLineup from "../components/simulatorLineup/simulatorLineup";
import { lineupMXConfig } from "../components/simulatorLineup/configs/lineupMX.config";

export default function SimulatorLineupMXPage() {
  return (
    <div className="simulador-page">
      <SimulatorLineup config={lineupMXConfig} />
    </div>
  );
}
